import Terms from './Terms'
import Cookies from './Cookies'
import Privacy from './Privacy'
import CookieBar from './CookieBar'

export {
  Terms, Cookies, Privacy, CookieBar
}
